import { Calendar } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '../ui/tooltip';
import { Progress } from '../ui/progress';
import _ from 'lodash';
import moment from 'moment';
//import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import Select from 'src/components/ui/BrandSelect';
import { AutoSizer, Column, Table } from 'react-virtualized';
import 'react-virtualized/styles.css';
import { Actions as ADMINACTIONS } from '../../store/actions/adminActions';
import { Actions as USAGEACTIONS } from '../../store/actions/usageActions';
import { Button } from '../ui/button';
import { Input } from 'src/components/ui/input';

const BulkEditModal = ({
  toggleModal,
  bulkEditModal,
  modalProps,
  modalData,
  branding,
  updateOrAddToDB,
  saveUsageData,
  progressState,
}) => {
  const [checked, setChecked] = useState({});
  const [selected, setSelected] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmBulkEdit, setConfirmBulkEdit] = useState(false);
  const [progressBarActive, setProgressBarActive] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [progress, setProgress] = useState(0);
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (progressState !== undefined) {
      setProgress(progressState);
      setProgressBarActive(true);
    }
  }, [progressState]);

  if (!bulkEditModal) return null;
  const { btn, modalTitle, modalTableTitle, hideBtns, elements, tableName } = modalProps;
  const tabelLabel = tableName === 'usageData' ? 'Usage Data' : 'Conversion Factors';
  const { primaryColor } = branding.colors;

  const updateDateOrSelect = (selectedInput, e) => {
    if (e) {
      const newSelected = { ...selected };
      if (e.name) {
        newSelected[e.name] = selectedInput;
      } else {
        newSelected['source'] = selectedInput;
      }
      setSelected(newSelected);
    }
  };

  //to update checkbox
  const updateChecked = (e) => {
    const { name } = e.target;
    const newChecked = { ...checked };
    newChecked[name] = !newChecked[name];
    if (!newChecked[name]) {
      const newSelected = { ...selected };
      newSelected[name] = false;
      setSelected(newSelected);
    }
    setChecked(newChecked);
  };

  const trueChecked = Object?.keys(checked).filter((item) => checked[item] === true);
  const lengthOfSelected = Object?.keys(selected).filter(
    (item) => (typeof selected[item] === 'string' && selected[item].length >= 1) || typeof selected[item] === 'object'
  ).length;

  const bulkSelectionOK = trueChecked?.length >= 1 && lengthOfSelected >= 1 && trueChecked?.length === lengthOfSelected;

  const makeNewData = () => {
    const newItem = {};

    Object.keys(selected).forEach((optionType) => {
      Array.isArray(selected[optionType])
        ? (newItem[optionType] = selected[optionType].map((item) => {
            return item?.value.toString();
          }))
        : (newItem[optionType] = selected[optionType]['value']?.toString());
    });
    return modalData?.map((item) => {
      const newData = { ...item, ...newItem };
      return newData;
    });
  };

  const formatUsageTypesValues = (data) => {
    const { dataKey, cellData } = data;
    const options = _.find(elements, { name: dataKey })?.options;
    if (dataKey === 'source' || dataKey === 'discontinuedDate') {
      return (
        <div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div style={{ cursor: 'pointer' }} className='admin_portal_cellData_description'>
                  {cellData}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p style={{ fontSize: 12, marginBottom: 0 }}>{cellData}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      );
    } else if (dataKey === 'addOns') {
      return (
        <div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div style={{ cursor: 'pointer' }} className='admin_portal_cellData_description'>
                  {cellData && cellData?.map((item) => _.find(options, { value: item })?.label + ' ')}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p style={{ fontSize: 12, marginBottom: 0 }}>
                  {cellData?.map((item) => _.find(options, { value: item })?.label + ' ')}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      );
    } else if (dataKey) {
      return (
        <div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div style={{ cursor: 'pointer' }} className='admin_portal_cellData_description'>
                  {cellData && _.find(options, { value: cellData })?.label}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p style={{ fontSize: 12, marginBottom: 0 }}>{cellData && _.find(options, { value: cellData })?.label}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      );
    }
  };

  return (
    <>
      {confirmModal ? (
        <div className='modal' style={{ display: 'flex', alignItems: 'center', background: 'rgba(0,0,0,.5)' }}>
          <div className='modal-dialog modal-autoheight' style={{ fontSize: '12px', width: 'auto' }}>
            <div className='modal-content' style={{ margin: '70px auto', width: 'auto', maxHeight: '100%', height: 'auto' }}>
              <div className='modal-header'>
                <button type='button' onClick={() => toggleModal(false, null)} className='close'>
                  x
                </button>
                <h4 className='modal-title' style={{ textAlign: 'center' }}>
                  {modalTitle.replace('select', 'confirm')}
                </h4>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <h3 style={{ textAlign: 'center', borderBottom: '2px solid black', color: 'black' }}>Selected Changes</h3>
                <div style={{ height: '15vh', overflowX: 'hidden', overflowY: 'auto', width: '100%', paddingTop: '2vh' }}>
                  {trueChecked?.map((item, index) => (
                    <div
                      style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        width: 'fit-content',
                      }}>
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                        }}>
                        <h4>
                          <b>{item.charAt(0).toUpperCase() + item.slice(1)} -</b>
                        </h4>
                        <h4 style={{ color: primaryColor, paddingLeft: '5px' }}>
                          <b>
                            {Array.isArray(selected[item])
                              ? selected[item]?.map((item) => {
                                  return item?.label + ', ';
                                })
                              : selected[item]?.label}
                          </b>
                        </h4>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <h2 style={{ textAlign: 'center' }}>{modalTableTitle}</h2>
              <div
                className='modal-body'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: '25vh',
                  width: '150vh',
                }}>
                <div style={{ width: '100%', height: '100%' }}>
                  <AutoSizer>
                    {({ width, height }) => (
                      <Table
                        width={width}
                        height={height}
                        rowHeight={40}
                        headerHeight={50}
                        rowCount={modalData.length}
                        rowGetter={({ index }) => modalData[index]}>
                        {elements.map((el, index) => (
                          <Column
                            key={index}
                            width={60}
                            label={el.label}
                            dataKey={el.name}
                            flexGrow={3}
                            cellRenderer={formatUsageTypesValues}
                          />
                        ))}
                      </Table>
                    )}
                  </AutoSizer>
                </div>
              </div>
              <div
                className='modal-footer'
                style={{ display: hideBtns ? 'none' : 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <div>
                  {' '}
                  <div className='flex items-center gap-2'>
                    <Checkbox checked={confirmBulkEdit} onCheckedChange={(checked) => setConfirmBulkEdit(checked)} />
                    <label className='text-sm'>By clicking you confirm the changes above are correct.</label>
                  </div>
                </div>
                <div style={{ display: hideBtns ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {' '}
                  <Button
                    variant='destructive'
                    type={btn?.type}
                    onClick={() => {
                      setConfirmModal(false);
                    }}>
                    Back
                  </Button>
                  <Button
                    disabled={!confirmBulkEdit}
                    variant='default'
                    className='bg-success text-white hover:bg-success/90'
                    type={btn?.type}
                    onClick={() => {
                      if (tableName === 'usageData') {
                        setTimeout(() => {
                          setConfirmModal(false);
                        }, 500);
                        saveUsageData(makeNewData(), true);
                      } else updateOrAddToDB(tableName, makeNewData());
                    }}>
                    Confirm
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : progressBarActive ? (
        <div className='modal' style={{ display: 'flex', alignItems: 'center', background: 'rgba(0,0,0,.5)' }}>
          <div className='modal-dialog modal-autoheight' style={{ fontSize: '12px', width: 'auto' }}>
            <div className='modal-content' style={{ margin: '70px auto', width: '65vh', maxHeight: '100%', height: 'auto' }}>
              <div className='modal-header'>
                <button type='button' onClick={() => toggleModal(false, null)} className='close'>
                  x
                </button>
                <h4 className='modal-title' style={{ textAlign: 'center' }}>
                  {tabelLabel} Bulk Edit Progress
                </h4>
              </div>
              <div className='w-full p-[50px]'>
                <div className='flex items-center h-[10vh]'>
                  <div className='w-[90%] mr-4 ml-[5vh]'>
                    <Progress value={progress} className='h-[7px] rounded-[5px]' />
                  </div>
                  <div className='min-w-[35px]'>
                    <span className='text-[2vh] text-muted-foreground'>{`${Math.round(progress)}%`}</span>
                  </div>
                </div>
                {progress === 100 && (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <p>{tabelLabel} has been bulk edited Successfully!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className='modal'
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,.5)' }}>
          <div className='modal-dialog' style={{ width: 'auto', height: 'auto', fontSize: '12px' }}>
            <div className='modal-content' style={{ margin: 'auto' }}>
              <div className='modal-header'>
                <button type='button' onClick={() => toggleModal(false, null)} className='close'>
                  x
                </button>
                <h4 className='modal-title' style={elements && { textAlign: 'center', paddingRight: '3vh' }}>
                  {modalTitle}
                </h4>
              </div>
              <div
                className='modal-body'
                style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '80vh', overflowY: 'auto' }}>
                {elements.map((el, index) => {
                  const elName = el.name;
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingBottom: '2vh',
                      }}>
                      <div style={{ display: 'contents' }}>
                        <div style={{ width: '20vh' }}>
                          <label style={{ display: 'contents', fontSize: '14px' }}>{el.label}</label>
                        </div>
                        <div style={{ width: '10vh' }}>
                          <Checkbox
                            onCheckedChange={(isChecked) => updateChecked({ target: { name: elName, checked: isChecked } })}
                            checked={checked[elName] || false}
                            name={elName}
                            style={{ marginRight: '3vh' }}
                          />
                        </div>
                        <div style={{ width: '63%', height: 'auto' }}>
                          {checked[elName] &&
                            (el.component === 'select' ? (
                              <div className='row' style={{ width: '213%' }}>
                                <div className='col-xs-6'>
                                  <Select
                                    name={elName}
                                    options={el.options}
                                    onChange={(selectedOption, e) => {
                                      updateDateOrSelect(selectedOption, e);
                                    }}
                                    value={selected[elName]}
                                    isClearable={false}
                                    isSearchable={true}
                                    isMulti={el?.isMulti}
                                  />
                                </div>
                              </div>
                            ) : el.component === 'datePicker' ? (
                              checked[elName] &&
                              el.component === 'datePicker' && (
                                <div className='row' style={{ width: '213%' }}>
                                  <div className='col-xs-6'>
                                    <label className='input-group date datepicker'>
                                      <DatePicker
                                        name={elName}
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        dateFormat='dd/MM/yyyy'
                                        className='h-9 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-sm startDate'
                                        popperPlacement='bottom-end'
                                        yearDropdownItemNumber={5}
                                        isClearable={true}
                                        maxDate={new Date()}
                                        placeholderText='Discontinued Date'
                                        onChange={(date, e) => {
                                          let obj = {
                                            value: moment(date).format('YYYY-MM-DD'),
                                            label: moment(date).format('YYYY-MM-DD'),
                                            name: elName,
                                          };
                                          updateDateOrSelect(obj, {
                                            label: moment(date).format('YYYY-MM-DD'),
                                            name: elName,
                                          });
                                          setDate(date);
                                        }}
                                        selected={date}
                                        popperModifiers={{ offset: { enabled: true, offset: '77px, 0px' } }}
                                      />
                                      <span className='input-group-btn'>
                                        <Button variant='ghost' size='sm' className='date-set'>
                                          <Calendar size={16} strokeWidth={1.5} />
                                        </Button>
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className='row' style={{ width: '213%' }}>
                                <div className='col-xs-6'>
                                  <Input
                                    type={el?.type}
                                    name={elName}
                                    onChange={(e) => {
                                      let obj = { value: e.target.value, label: e.target.value };
                                      setInputValue(e.target.value);
                                      updateDateOrSelect(obj, e);
                                    }}
                                    value={inputValue}
                                    placeholder='Source'
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  );
                })}

                {bulkSelectionOK && (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      className='bg-success text-white hover:bg-success/90'
                      style={btn?.style}
                      type={btn?.type}
                      onClick={() => {
                        setConfirmModal(true);
                      }}>
                      {btn?.title}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

};

const mapStateToProps = (state) => {
  return {
    modalData: state.admin?.modal?.item,
    modalProps: state.admin?.modal?.modalProps,
    branding: state.branding,
    bulkEditModal: state?.admin?.modal?.bulkEditModal,
    progressState: state?.progress,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, action) => dispatch(ADMINACTIONS.toggleModal(status, action)),
  updateOrAddToDB: (table, item) => dispatch(ADMINACTIONS.updateOrAddToDB(table, item)),
  saveUsageData: (usageData, adminPortal) => dispatch(USAGEACTIONS.saveUsageData(usageData, adminPortal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkEditModal);
